"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.success.title': 'Account attivato!',
    'activate.success.description': 'Il tuo account è stato attivato con successo. Ora puoi accedere e iniziare a usare IntHub.',
    'activate.success.message': 'Account attivato con successo!',
};
